import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";

export default class OutgoingPayGateReversalPaymentsRequest {
  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => DateRangeRequest)
  authorizedDate?: DateRangeRequest;

  @observable
  @Type(() => DecimalRangeRequest)
  paidAmount?: DecimalRangeRequest;

  @observable
  cardNumber?: string;

  @observable
  arn?: string;
}

export const OutgoingPayGateReversalFiltersValidationRules: EntityValidationRules<OutgoingPayGateReversalPaymentsRequest> = {
  variableSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  arn: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  paidAmount: {
    isNumberRange: {
      min: 0,
    },
  },
};
